<template>
    <div v-if="!loading">
        <div v-if="!innerIsReview">
            <validation-provider
                v-slot="{ errors }"
                :name="label || 'This'"
                :rules="rules"
                v-bind="providerProps"
                v-show="innerShouldShow"
                :vid="'validate-' + fieldAssignmentId"
            >
                <div v-if="!isGridSelection">
                    <template v-if="mode === 'radio'">
                        <v-radio-group v-model="innerValue">
                            <div
                                v-for="(option, i) in templates"
                                :class="[
                                    'mb-3 checkbox-new radio-new',
                                    innerValue === option.id ||
                                    innerValue === option
                                        ? 'selected'
                                        : null
                                ]"
                                :key="i"
                            >
                                <v-radio
                                    v-bind="vProps"
                                    :label="option.name"
                                    :error-messages="errors"
                                    :value="option.id"
                                ></v-radio>
                            </div>
                        </v-radio-group>
                    </template>
                    <v-select
                        v-else
                        v-model="innerValue"
                        v-bind="vProps"
                        :items="templates"
                        item-text="name"
                        item-value="id"
                        :chips="isMultiple"
                        :deletable-chips="isMultiple"
                        :multiple="isMultiple"
                        :error-messages="errors"
                    >
                        <template #label>
                            <span v-if="innerLabel" v-html="innerLabel"></span>
                        </template>
                    </v-select>
                </div>
                <div v-else>
                    <type-grid-selection
                        v-model="innerValue"
                        :fieldAssignmentId="fieldAssignmentId"
                        :type="type"
                        :type_attributes="type_attributes"
                        :name="name"
                        :label="label"
                        :directions="directions"
                        :default_value="default_value"
                        :componentProps="componentProps"
                        :extraProps="extraProps"
                        :settings="settings"
                        :validation_settings="validation_settings"
                        :value_options="templates"
                        :field_path="field_path"
                        :hideRequired="hideRequired"
                        :providerProps="providerProps"
                    ></type-grid-selection>
                </div>
            </validation-provider>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    <span v-html="templateName"></span>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin';
import $api from '@api/api';
import TypeReview from './TypeReview';
import TypeGridSelection from './TypeGridSelection';

export default {
    name: 'TypeTemplateSelection',
    mixins: [formMixin],
    components: {
        TypeReview,
        TypeGridSelection
    },
    props: {
        mode: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            loading: true,
            templates: []
        };
    },
    methods: {
        async getTemplates() {
            if( this.value_options?.length ) {
                this.templates = this.value_options;
                return;
            }

            const params = {parentId: (this.settings && this.settings.template_parent_id) || 0};
            if( this.settings.limit_items )
                params.ids = this.settings.limit_items;

            const { data } = await $api.templates.getTemplates(params);
            this.templates = data;
        }
    },
    async mounted() {
        await this.getTemplates();
        if (this.isGridSelection) {
            this.componentProps.valAttr = 'id';
        }
        this.fieldLoaded(); // signal to the form we are loaded
        this.loading = false;
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                items: this.value_options || [],
                persistentHint: true
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {};
        },
        isMultiple() {
            return this.type_attributes?.indexOf('Multiple') > -1;
        },
        isGridSelection() {
            return this.type_attributes?.indexOf('GridSelection') > -1;
        },
        templateName() {
            // TODO this should probably be a getter in store
            let v = this.templates.find(x => x.id === this.innerValue);
            return (v && v.name) || null;
        }
    },
    watch: {
        innerValue(n, o) {
            if (this.settings?.set_name) {
                let f = this.templates.find(x => x.id == n);
                if (f) {
                    const paths = this.field_path.split('.');
                    this.setSiblingValue(paths[0] + '.name', f.name);
                }
            }
        }
    }
};
</script>

<style lang="scss">
.radio-new {
    .v-label {
        margin: 0;
    }
}
</style>
